(function(){
	const DURATION_MS=250;

	const getWrapper=function(btn){
		return btn.parentElement;
	};

	const getContentEl=function(btn){
		const wrapper=getWrapper(btn);

		if(!wrapper){
			return null;
		}

		return wrapper.querySelector('[data-accordion-content]');
	};

	const setActionIcon=function(btn,expanded){
		const icon=btn.querySelector('.features-item-action-icon i');

		if(!icon){
			return;
		}

		if(expanded){
			icon.classList.remove('icon-keyboard_arrow_down');
			icon.classList.add('icon-keyboard_arrow_up');

			return;
		}

		icon.classList.remove('icon-keyboard_arrow_up');
		icon.classList.add('icon-keyboard_arrow_down');
	};

	const ensureTransition=function(el){
		const current=el.style.transition;

		if(!current||current.indexOf('height')===-1){
			el.style.transition='height '+DURATION_MS+'ms ease';
		}
	};

	const isAnimating=function(content){
		return content.dataset.animating==='1';
	};

	const setAnimating=function(content,val){
		if(val){
			content.dataset.animating='1';

			return;
		}

		delete content.dataset.animating;
	};

	const openPanel=function(btn,content){
		if(isAnimating(content)){
			return;
		}

		ensureTransition(content);

		const target=content.scrollHeight;
		const wrapper=getWrapper(btn);

		setAnimating(content,true);

		content.classList.remove('closed');

		content.style.height='0px';
		void content.offsetHeight;

		content.style.height=target+'px';
		btn.setAttribute('aria-expanded','true');
		setActionIcon(btn,true);

		if(wrapper){
			wrapper.classList.add('active');
		}

		const onEnd=function(ev){
			if(ev.propertyName!=='height'){
				return;
			}

			content.style.height='';
			content.removeEventListener('transitionend',onEnd);
			setAnimating(content,false);
		};

		content.addEventListener('transitionend',onEnd);
	};

	const closePanel=function(btn,content){
		if(isAnimating(content)){
			return;
		}

		ensureTransition(content);

		const current=content.scrollHeight;
		const wrapper=getWrapper(btn);

		setAnimating(content,true);

		content.style.height=current+'px';
		void content.offsetHeight;

		content.style.height='0px';
		btn.setAttribute('aria-expanded','false');
		setActionIcon(btn,false);

		if(wrapper){
			wrapper.classList.remove('active');
		}

		const onEnd=function(ev){
			if(ev.propertyName!=='height'){
				return;
			}

			content.classList.add('closed');
			content.removeEventListener('transitionend',onEnd);
			setAnimating(content,false);
		};

		content.addEventListener('transitionend',onEnd);
	};

	const setOpen=function(btn,open){
		const content=getContentEl(btn);

		if(!content){
			return;
		}

		if(open){
			openPanel(btn,content);

			return;
		}

		closePanel(btn,content);
	};

	const onClick=function(e){
		const btn=e.target.closest('[data-accordion-toggle]');

		if(!btn){
			return;
		}

		e.preventDefault();

		const content=getContentEl(btn);

		if(!content||isAnimating(content)){
			return;
		}

		const expanded=btn.getAttribute('aria-expanded')==='true';

		setOpen(btn,!expanded);
	};

	const initScope=function(root){
		const scope=root||document;
		const items=scope.querySelectorAll('[data-accordion="features-item"] [data-accordion-content]');
		const buttons=scope.querySelectorAll('[data-accordion="features-item"] [data-accordion-toggle]');

		items.forEach(function(el){
			ensureTransition(el);
			el.style.height='0px';
			el.classList.add('closed');
		});

		buttons.forEach(function(btn){
			btn.setAttribute('aria-expanded','false');
			setActionIcon(btn,false);

			const wrapper=getWrapper(btn);

			if(wrapper){
				wrapper.classList.remove('active');
			}
		});
	};

	document.addEventListener('click',onClick);

	if(document.readyState==='loading'){
		document.addEventListener('DOMContentLoaded',function(){
			initScope();
		});
	}else{
		initScope();
	}
})();
